module.exports = __webpack_public_path__ + "img/健康预警机器人ppt-13.a0d24e6c.jpg";